<template>
  <v-sheet fill-height id="layout-default" :color="baseBgColor">
    <v-navigation-drawer
      v-model="drawer"
      :mini-variant="mini"
      :color="appDrawerColor"
      app
    >
      <v-divider class="mt-16 mb-10" />

      <v-card
        flat
        tile
        v-if="user || partner"
        class="card-center"
        color="transparent"
      >
        <v-card-text class="flex-items column">
          <BrandLogoLoader
            :size="!mini ? 150 : 42"
            :infinite="loading"
            class="mb-5"
          />

          <div class="text-left pl-2" v-if="!mini">
            <h2 class="text-capitalize">{{ user.name }}</h2>
            <h5>{{ user.email }}</h5>
          </div>
        </v-card-text>
      </v-card>

      <v-divider class="my-5" />
      <h5 class="pl-5 opacity" v-if="!mini"></h5>

      <v-list dense>
        <v-list-item exact link to="/dashboard">
          <v-list-item-action>
            <v-icon>$vuetify.icons.dashboard</v-icon>
          </v-list-item-action>

          <v-list-item-content>
            Dashboard
          </v-list-item-content>
        </v-list-item>
        <!--
                <v-list-item exact link to="/confirmed">

                    <v-list-item-action>
                        <v-icon>$vuetify.icons.customers_confirmed</v-icon>
                    </v-list-item-action>


                    <v-list-item-content>
                        Confirmed
                    </v-list-item-content>

                </v-list-item>

                <v-list-item exact link to="/activated">

                    <v-list-item-action>
                        <v-icon>$vuetify.icons.customers_activated</v-icon>
                    </v-list-item-action>


                    <v-list-item-content>
                        Activated
                    </v-list-item-content>

                </v-list-item>

                <v-list-item exact link to="/no-match">

                    <v-list-item-action>
                        <v-icon>$vuetify.icons.customers_nomatch</v-icon>
                    </v-list-item-action>


                    <v-list-item-content>
                        Unmatched
                    </v-list-item-content>

                </v-list-item>
                -->
        <v-list-item exact link to="/surveys" v-if="showSurveys">
          <v-list-item-action>
            <v-icon>$vuetify.icons.surveys</v-icon>
          </v-list-item-action>

          <v-list-item-content>
            Surveys
          </v-list-item-content>
        </v-list-item>

        <v-list-item exact link to="/properties" v-if="showProperties">
          <v-list-item-action>
            <v-icon>$vuetify.icons.properties</v-icon>
          </v-list-item-action>

          <v-list-item-content>
            Properties
          </v-list-item-content>
        </v-list-item>

        <v-list-item exact link to="/policies" v-if="showPolicies">
          <v-list-item-action>
            <v-icon>$vuetify.icons.policies</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            Policies
          </v-list-item-content>
        </v-list-item>

        <v-list-item exact link to="/rewards" v-if="showRewards">
          <v-list-item-action>
            <v-icon>$vuetify.icons.rewards</v-icon>
          </v-list-item-action>

          <v-list-item-content>
            Rewards
          </v-list-item-content>
        </v-list-item>
        <!--
                <v-list-item exact link to="/reports">

                    <v-list-item-action>
                        <v-icon>$vuetify.icons.customers_export</v-icon>
                    </v-list-item-action>


                    <v-list-item-content>
                        Reports
                    </v-list-item-content>

                </v-list-item>
                -->

        <v-divider class="my-5" />

        <v-list-item @click="logout">
          <v-list-item-action>
            <v-icon>$vuetify.icons.logout</v-icon>
          </v-list-item-action>

          <v-list-item-content>
            Log-Out
          </v-list-item-content>
        </v-list-item>

        <v-divider class="my-5" />

        <v-list-item @click="updateMini(!mini)">
          <v-list-item-action>
            <v-icon>$vuetify.icons.mini_mode</v-icon>
          </v-list-item-action>

          <v-list-item-content>
            {{ mini ? "Expand" : "Minimize" }}
          </v-list-item-content>
        </v-list-item>

        <v-list-item>
          <v-list-item-action>
            <v-icon
              v-html="
                dark ? '$vuetify.icons.dark_mode' : '$vuetify.icons.bright_mode'
              "
            ></v-icon>
          </v-list-item-action>

          <v-list-item-content>
            <v-switch
              :value="dark"
              :input-value="dark"
              :label="`Eco Mode`"
              @change="updateDark(!dark)"
              hide-details
              class="ma-0"
            ></v-switch>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-spacer />
      <!--
            <v-card flat tile color="transparent" v-if="!mini">
                <v-card-text class="pl-5 opacity">Customer Apps</v-card-text>
                <v-card-text class="text-left">
                    <v-btn  block :href="`https://${partner.hostedDomain}`" target="_blank"
                        class="btn_native_app">
                        <v-icon >mdi-web</v-icon>
                        PWA
                    </v-btn>

                    <v-btn  block :href="partner.nativeAppLink_Android" target="_blank" class="btn_native_app"
                        v-if="partner.nativeAppLink_Android">
                        <v-icon >mdi-google-play</v-icon>
                        <div>
                            <small>GET IT ON</small>
                            <h4>Google Play</h4>
                        </div>
                    </v-btn>

                    <v-btn  block :href="partner.nativeAppLink_iOS" target="_blank" class="btn_native_app"
                        v-if="partner.nativeAppLink_iOS">
                        <v-icon >mdi-apple</v-icon>
                        <div>
                            <small>GET IT ON</small>
                            <h4>App Store</h4>
                        </div>
                    </v-btn>
                </v-card-text>
            </v-card>
            <v-spacer />-->

      <!-- <v-card flat tile class="card-center flex-items column">
                <PwaInstallerBtn class="ma-3 my-5" />
            </v-card> -->

      <v-card flat tile>
        <v-card-actions>
          <v-spacer />

          <v-avatar :size="36">
            <v-img
              :src="`https://parked.blob.core.windows.net/ownli/www/logos/logo.png`"
            />
          </v-avatar>

          <v-spacer />

          <div class="text-left pr-2" style="font-size: 0.72rem;" v-if="!mini">
            <span>Powered by Ownli {{ year }}</span
            ><br />
            <a
              href="https://support.ownli.co/hc/en-us/articles/360011275958-Terms-of-Service"
              target="_blank"
              >Terms of use</a
            >
            &
            <a
              href="https://support.ownli.co/hc/en-us/sections/360003247337-Privacy-and-security"
              target="_blank"
              >Privacy policy</a
            >
          </div>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-navigation-drawer>

    <v-app-bar app flat :color="appBarColor">
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>

      <v-toolbar-title class="pa-0 mr-1" v-if="partner">{{
        partner.name
      }}</v-toolbar-title>
      <v-toolbar-title class="pa-0" v-html="title"></v-toolbar-title>

      <v-spacer></v-spacer>
    </v-app-bar>

    <v-main fill-height class="pos-r d-flex align-start">
      <v-progress-linear
        indeterminate
        absolute
        top
        left
        height="5"
        color="primary"
        v-show="loading"
      />

      <transition name="fade" mode="out-in">
        <slot />
      </transition>
    </v-main>
  </v-sheet>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import NetworkIndicator from "@/components/NetworkIndicator";
import PwaInstallerBtn from "@/components/PwaInstallerBtn";

export default {
  name: "DefaultLayout",

  components: {
    NetworkIndicator,
    PwaInstallerBtn,
  },

  computed: {
    ...mapGetters("auth", ["authenticated", "user", "partner"]),
    ...mapGetters("appshell", [
      "dark",
      "mini",
      "connected",
      "platform",
      "isMobileDevice",
      "loading",
      "sysNotifications",
    ]),

    title() {
      return this.$route.meta.title || document.title;
    },

    year() {
      return new Date().getFullYear();
    },
    appBarColor() {
      return !this.dark ? "white" : "black";
    },
    appDrawerColor() {
      return !this.dark ? "white" : "black";
    },
    baseBgColor() {
      return !this.dark ? "grey lighten-4" : "black";
    },
  },

  methods: {
    ...mapActions("auth", ["login", "logout"]),
    ...mapActions("appshell", ["updateDark", "updateMini"]),
  },

  mounted() {
    if (this.partner) {
      //console.log(this.partner.name);
      if (this.partner.name == "SimplyIOA" || this.partner.name == 'Novo' || this.partner.name == 'Rein' ||this.partner.name == 'AADirect') {
        this.showProperties = false;
        this.showRewards = false;
        this.showPolicies = false;
        this.showSurveys = false;
      } else if (this.partner.name == "BlackboxMyCar") {
        this.showProperties = false;
        this.showRewards = false;
        this.showPolicies = false;
      } else if (this.partner.name == "Kentucky National Insurance Co") {
        this.showProperties = true;
        this.showRewards = false;
        this.showPolicies = false;
      }
    }
  },

  data: () => ({
    dialog: false,
    drawer: null,
    showProperties: true,
    showRewards: true,
    showPolicies: true,
    showSurveys: true,
  }),
};
</script>

<style lang="css" scoped>
#layout-default >>> .v-navigation-drawer__content {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: end;
}

#layout-default >>> .v-list-item__content {
  padding: 8px 0;
  font-size: 0.9rem;
}

.btn_native_app {
  margin: 6px auto;
}

.btn_native_app >>> .v-btn__content {
  align-items: center;
  justify-content: flex-start;
}

.btn_native_app >>> .v-btn__content > .v-icon {
  margin-right: 15px;
}

.btn_native_app >>> small {
  font-size: 0.6rem;
  font-weight: 300;
}
</style>
